import { render, staticRenderFns } from "./EmailReceivedCard.vue?vue&type=template&id=9e936d86"
import script from "./EmailReceivedCard.vue?vue&type=script&lang=js"
export * from "./EmailReceivedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports